module.exports = new __parcel__URL__("logo.4d7cf4ed.png").toString();